import { InjectionToken } from '@angular/core';

const LOADING_INDICATOR_PRIMARY = new InjectionToken('loading-indicator.primary');
const LOADING_INDICATOR_SECONDARY = new InjectionToken('loading-indicator.secondary');

const THEME = new InjectionToken('vm.theme');

const THEME_ICONS = new InjectionToken('THEME_ICONS');

/**
 * Generated bundle index. Do not edit.
 */

export { LOADING_INDICATOR_PRIMARY, LOADING_INDICATOR_SECONDARY, THEME, THEME_ICONS };
